import { SimpleGrid } from '@homebotapp/hb-react-component-catalog'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import {
  ESS_WIN,
  HOME_INSURANCE_WIN,
  NEW_HOME_WIN,
  REFI_WIN,
  RESERVE_WIN,
  SHARE_WIN,
  SHOULD_YOU_SELL_WIN
} from '../../../constants/wins'

import {
  selectShouldDisplayShouldYouSell,
  selectShouldRenderCashout,
  selectShouldRenderEmergencyReserve,
  selectShouldRenderEquitySmartSearchFeatures,
  selectShouldRenderHomeInsuranceModule,
  selectShouldRenderRefiOptions
} from '../../../store/selectors/display'

import { selectDisableGetLeadsFeature } from '../../../store/selectors/customerProfile'

import Ess from './Wins/Ess'
import HomeInsurance from './Wins/HomeInsurance'
import NewHome from './Wins/NewHome'
import Refi from './Wins/Refi'
import Reserve from './Wins/Reserve'
import Share from './Wins/Share'
import ShouldYouSell from './Wins/ShouldYouSell'

export const ImportantNowScrollView = ({ recommendations, setHideParentPanel }) => {
  // Redux selectors
  const shouldRenderShouldYouSell = useSelector(selectShouldDisplayShouldYouSell)
  const shouldRenderEquitySmartSearch = useSelector(selectShouldRenderEquitySmartSearchFeatures)
  const shouldRenderHomeInsurance = useSelector(selectShouldRenderHomeInsuranceModule)
  const shouldRenderEmergencyReserve = useSelector(selectShouldRenderEmergencyReserve)
  const shouldRenderRefiOptions = useSelector(selectShouldRenderRefiOptions)
  const shouldRenderCashout = useSelector(selectShouldRenderCashout)

  const disableGetLeadsFeature = useSelector(selectDisableGetLeadsFeature)

  const winsToDisplay = recommendations.map(recommendation => {
    // Check the corresponding Redux selector for each recommendation code
    switch (recommendation.recommendationCode) {
      case SHARE_WIN:
        return shouldRenderShouldYouSell && !disableGetLeadsFeature
          ? {
              component: <Share key={recommendation.id} />,
              priority: recommendation.priority
            }
          : null
      case RESERVE_WIN:
        return shouldRenderEmergencyReserve
          ? {
              component: <Reserve key={recommendation.id} />,
              priority: recommendation.priority
            }
          : null
      case REFI_WIN:
        return shouldRenderRefiOptions
          ? {
              component: <Refi key={recommendation.id} />,
              priority: recommendation.priority
            }
          : null
      case HOME_INSURANCE_WIN:
        return shouldRenderHomeInsurance
          ? {
              component: <HomeInsurance key={recommendation.id} />,
              priority: recommendation.priority
            }
          : null
      case ESS_WIN:
        return shouldRenderEquitySmartSearch
          ? {
              component: <Ess key={recommendation.id} />,
              priority: recommendation.priority
            }
          : null
      case NEW_HOME_WIN:
        return shouldRenderCashout
          ? {
              component: <NewHome key={recommendation.id} />,
              priority: recommendation.priority
            }
          : null
      case SHOULD_YOU_SELL_WIN:
        return shouldRenderShouldYouSell
          ? {
              component: <ShouldYouSell key={recommendation.id} />,
              priority: recommendation.priority
            }
          : null
      default:
        return null // Handle other recommendation codes as needed
    }
  })

  // Removes null values, sorts by priority, and limits to 3
  const processedWinsToDisplay = winsToDisplay
    .filter(win => win !== null)
    .sort((a, b) => a?.priority - b?.priority)
    .slice(0, 3)

  // Hide parent panel if there are less than 2 wins to display
  useEffect(() => {
    setHideParentPanel(processedWinsToDisplay.length < 2)
  }, [processedWinsToDisplay.length, setHideParentPanel])

  return (
    <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={5}>
      {processedWinsToDisplay.map(win => {
        return win.component
      })}
    </SimpleGrid>
  )
}
